<template>
  <div>
    <div v-if="community.length > 0">
      <div class="im-dark" v-show="communityIsShow">
        <el-popover placement="left" trigger="click">
          <div class="pop-wrap">
            <div class="pop-wrap-item">
              <div class="qr-wrap">
                <div class="qr-label">
                  <div class="title">
                    <div class="ui-icon ui-icon-ewm"></div>
                    {{ community[0].name }}
                  </div>
                  <div class="online-des">微信扫码加入专属社群</div>
                </div>
                <div class="qr-img">
                  <img :src="community[0].text" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="im-btn-grey" slot="reference">
            <div class="icon">
              <img src="../../assets/images/common/im-1.png" alt="" />
            </div>

            <div class="text">加入社区</div>
          </div>
        </el-popover>

        <el-popover placement="left" trigger="click">
          <div class="pop-wrap">
            <div class="pop-wrap-item">
              <div class="qr-wrap">
                <div class="qr-label">
                  <div class="title">
                    <div class="ui-icon ui-icon-ewm"></div>
                    {{ community[1].name }}
                  </div>
                  <div class="online-des">微信扫码加入专属社群</div>
                </div>
                <div class="qr-img">
                  <img :src="community[1].text" alt="" />
                </div>
              </div>
            </div>

            <div class="line"></div>

            <div class="pop-wrap-item">
              <div class="qr-wrap">
                <div class="qr-label">
                  <div class="title">
                    <div class="ui-icon ui-icon-ewm"></div>
                    {{ community[2].name }}
                  </div>
                  <div class="online-des">QQ扫码加入专属社群</div>
                </div>
                <div class="qr-img">
                  <img :src="community[2].text" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="im-btn-grey" slot="reference">
            <div class="icon">
              <img src="../../assets/images/common/im-2.png" alt="" />
            </div>
            <div class="text">客服服务</div>
          </div>
        </el-popover>

        <!-- <el-popover visible-arrow="false" placement="left" trigger="click">
					<div class="pop-wrap">
					<div class="pop-wrap-item">
						<div class="title">
						<div class="ui-icon ui-icon-phone"></div>
						<a href="tel:400-8571-888" class="phone-number">400-8571-888</a>
						</div>
						<div class="online-des">周一至周日8:00 - 22:00</div>
					</div>

					<div class="line"></div>

					<div class="pop-wrap-item">
						<div class="title">
						<div class="ui-icon ui-icon-serve"></div>
						在线客服
						</div>
						<div class="online-des">点击联系在线客服</div>
					</div>
					</div>

					<div class="im-btn-grey" slot="reference">
					<div class="icon">
						<img src="../../../assets/images/common/im-2.png" alt="" />
					</div>
					<div class="text">客服服务</div>
					</div>
				</el-popover> -->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Popover } from "element-ui";
Vue.use(Popover);

export default {
  name: "sidebar",
  props: {},
  created() {
    this.getCommunity();
  },
  computed: {
    ...mapState({
      community: (state) => state.index.community,
      communityIsShow: (state) => state.index.communityIsShow,
    }),
  },
  methods: {
    ...mapActions({
      getCommunity: "index/getCommunity",
    }),
  },
};
</script>

<style lang="scss">
.el-popover {
  padding: 0.1rem;
  background: rgba($color: #ffffff, $alpha: 0.8);
  box-shadow: 0px 4px 0px -2px rgba($color: #000000, $alpha: 0.5);
  border-radius: 0.1rem;
}
.el-popper[x-placement^="left"] .popper__arrow {
  opacity: 0.8;
}
</style>
<style lang="scss" scoped>
.im-dark {
  position: fixed;
  bottom: 3rem;
  right: 0;
  z-index: 10;
  .im-btn-grey {
    background: rgba($color: #ffffff, $alpha: 0.8);
    width: 1.2rem;
    height: 1.2rem;
    border: 1px solid #ffffff;
    box-shadow: 0px 4px 0px -2px rgba($color: #000000, $alpha: 0.5);
    border-radius: 0.1rem;
    text-align: center;
    padding: 0.1rem 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 0.28rem;

    .icon {
      img {
        height: 0.6rem;
      }
    }
    .text {
      font-size: 0.2rem;
      padding-top: 0.05rem;
      word-break: keep-all;
      color: #000;
    }
  }
}
.ui-icon {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  width: 0.34rem;
  height: 0.34rem;
  margin-right: 0.03rem;
}
.pop-wrap {
  position: relative;

  .qr-wrap {
    display: flex;
    .qr-label {
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
    }
    .qr-img {
      width: 76px;
      height: 76px;
      background: #eee;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 68px;
        height: 68px;
      }
    }

    .online-des {
      margin-top: 0.1rem;
    }
  }

  .line {
    border-bottom: 1px solid #585856;
    margin: 0.05rem 0 0.1rem;
  }

  .pop-wrap-item {
    .title {
      display: flex;
      align-items: center;
      color: #000000;
      font-size: 0.24rem;
      font-weight: bold;
      .ui-icon-phone {
        background-image: url("../../assets/images/common/im-3.png");
        background-size: 0.18rem auto;
      }
      .ui-icon-ewm {
        background-image: url("../../assets/images/common/im-5.png");
        background-size: 0.3rem auto;
      }

      a {
        color: #000000;
      }
      .ui-icon-serve {
        background-image: url("../../assets/images/common/im-4.png");
        background-size: 0.3rem auto;
      }
    }
    .online-des {
      font-size: 0.2rem;
      color: #5f5e5e;
      padding-left: 0.37rem;
    }
  }
}
</style>